import { EvtStatsCard } from "components/stats/display-card";
import { EvtStatsCardPlaceholder } from "components/stats/placeholder";
import QueryError from "components/query-error";
import React from "react";
import { useMilestoneSpentHours } from "components/milestone/stats/spent/useMilestoneSpentHours";
import { formatHoursToTime } from "components/timesheet/utils";

export const MilestoneTotalSpentHoursStat = ({ id, dateRange }) => {
  const { data, isLoading, isError, refetch, error } = useMilestoneSpentHours(
    id,
    dateRange
  );


  if (isLoading) {
    return <EvtStatsCardPlaceholder />;
  }
  if (isError) {
    return (
      <QueryError message="Failed to load Approved hours." onRetry={refetch} />
    );
  }

  return <EvtStatsCard label="Spent" value={formatHoursToTime(data)} />;
};
